<template>
  <v-main>
    <v-footer color="#f0f2f5" class="pa-7 flex-column elevation-5">
      <v-layout row wrap justify-center align-center>
        <v-flex xs11 lg11 pb-1 class="black--text text-center TextSize">
          Copyright © {{ new Date().getFullYear() }} Powered by INET. All rights
          reserved. <br />
          {{ $t("footer.contact") }}<br />
        </v-flex>
        <v-flex xs10 lg4 class="text-center">
          <a
            href="https://one.th/privacy-policy"
            target="blank"
            class="fontSize"
          >
            <v-btn class="font-weight-bold" color="#077893" text>{{
              $t("footer.Privacy")
            }}</v-btn>
          </a>
          <!-- <v-btn class="font-weight-bold" color="#077893" text>{{
            $t("footer.Privacy")
          }}</v-btn> -->
        </v-flex>
        <v-divider vertical class="d-none d-lg-flex d-xl-flex"></v-divider>
        <v-flex xs10 lg4 class="text-center">
          <v-btn
            class="font-weight-bold"
            color="#077893"
            text
            @click="Fn_OpenDialogPrivacyNotice"
            >{{ $t("footer.notice") }}</v-btn
          >
        </v-flex>
      </v-layout>
      <DialogPrivacyNotice
        :show="DialogPrivacyNotice"
        @closeDialogTerm="DialogPrivacyNotice = false"
      />
    </v-footer>
  </v-main>
</template>

<script>
import DialogPrivacyNotice from "../dialog/DialogPrivacyNotice.vue";
export default {
  components: { DialogPrivacyNotice },
  data() {
    return {
      DialogPrivacyNotice: false,
    };
  },

  methods: {
    Fn_OpenDialogPrivacyNotice() {
      this.DialogPrivacyNotice = true;
    },
  },
};
</script>

<style scoped>
.TextSize {
  font-size: 14px;
}
</style>
>
